module.exports = __webpack_public_path__ + "img/barra.e10561bd.png";